// @flow
import * as React from 'react';
import classNames from 'classnames/bind';
import HoverTooltip from '../../../basic-components/hover-tooltip';
import t from './locale/en.yml';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

type Props = {
  children: React.Node,
  id?: string,
  text?: string | React.Node,
  data?: { [string]: ?string },
  className?: string,
  disabled?: boolean,
};

export default function TableTooltip({
  children,
  id,
  text,
  data,
  className,
  disabled,
}: Props): React.Node {
  return (
    <HoverTooltip
      message={
        <div className={cx('content', className)}>
          {text || t(id || '', { ...data })}
        </div>
      }
      className={cx('tooltip')}
      disabled={disabled}
    >
      {children}
    </HoverTooltip>
  );
}
